<custom-app-bar
  [title]="'delete_account.title' | translate"
  [hasSafeArea]="false"
></custom-app-bar>

<div class="bottom-sheet__content">
  <p class="text">{{ "delete_account.text" | translate }}</p>
  <div class="buttons__container">
    <button
      class="button"
      customButton
      appearance="flat"
      size="large"
      (click)="closeBottomSheet(true)"
    >
      {{ "delete_account.yes" | translate }}
    </button>

    <button
      class="button"
      customButton
      appearance="ghost"
      size="large"
      (click)="closeBottomSheet(false)"
    >
      {{ "delete_account.no" | translate }}
    </button>
  </div>
</div>
